const STORAGE_KEY = "theme";
const root = document.documentElement;

const systemThemeQuery = window.matchMedia(
    "(prefers-color-scheme: dark)"
);

function getSavedTheme() {
    const savedTheme = localStorage.getItem(STORAGE_KEY);

    return savedTheme === "light" || savedTheme === "dark"
        ? savedTheme
        : null;
}

function getSystemTheme() {
    return systemThemeQuery.matches ? "dark" : "light";
}

function getCurrentTheme() {
    return root.getAttribute("data-bs-theme") || getSystemTheme();
}

function applyTheme(theme) {
    root.setAttribute("data-bs-theme", theme);

    document.querySelectorAll(".theme-toggle").forEach((button) => {
        const nextTheme = theme === "dark" ? "light" : "dark";

        button.setAttribute(
            "aria-label",
            `Switch to ${nextTheme} mode`
        );

        button.setAttribute(
            "aria-pressed",
            String(theme === "dark")
        );
    });
}

function toggleTheme() {
    const currentTheme = getCurrentTheme();
    const nextTheme = currentTheme === "dark" ? "light" : "dark";

    localStorage.setItem(STORAGE_KEY, nextTheme);
    applyTheme(nextTheme);
}

export function initTheme() {
    const initialTheme = getSavedTheme() || getSystemTheme();

    applyTheme(initialTheme);

    document.querySelectorAll(".theme-toggle").forEach((button) => {
        button.addEventListener("click", toggleTheme);
    });

    systemThemeQuery.addEventListener("change", (event) => {
        /*
         * Follow the operating-system theme only when the user
         * has not selected a theme manually.
         */
        if (getSavedTheme()) {
            return;
        }

        applyTheme(event.matches ? "dark" : "light");
    });
}